import httpClient from '~/lib/http-client';

/** A row from studio's memory curation API (user_memories). */
export interface UserMemory {
  id: string;
  kind: 'fact' | 'preference' | 'brand' | 'constraint';
  key: string;
  content: string;
  confidence: number;
  source: 'extracted' | 'remember_tool' | 'user';
  status: 'active' | 'rejected';
  useCount: number;
  lastUsedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function apiListMemories(): Promise<UserMemory[]> {
  const { data } = await httpClient.get<UserMemory[]>('/api/memory');
  return data;
}

export async function apiUpdateMemory(
  id: string,
  patch: { content?: string; kind?: UserMemory['kind']; status?: 'active' | 'rejected' },
): Promise<void> {
  await httpClient.patch(`/api/memory/${id}`, patch);
}

export async function apiDeleteMemory(id: string): Promise<void> {
  await httpClient.delete(`/api/memory/${id}`);
}

/** A row from project_memories, joined with its app's name for display. */
export interface ProjectMemory {
  id: string;
  projectId: string;
  projectName: string;
  kind: 'stack' | 'decision' | 'convention' | 'gotcha' | 'brand' | 'fact';
  key: string;
  content: string;
  confidence: number;
  source: 'extracted' | 'remember_tool' | 'user';
  status: 'active' | 'rejected';
  useCount: number;
  lastUsedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function apiListProjectMemories(): Promise<ProjectMemory[]> {
  const { data } = await httpClient.get<ProjectMemory[]>('/api/memory/projects');
  return data;
}

export async function apiUpdateProjectMemory(
  id: string,
  patch: { content?: string; kind?: ProjectMemory['kind']; status?: 'active' | 'rejected' },
): Promise<void> {
  await httpClient.patch(`/api/memory/projects/${id}`, patch);
}

export async function apiDeleteProjectMemory(id: string): Promise<void> {
  await httpClient.delete(`/api/memory/projects/${id}`);
}
